module.exports = __webpack_public_path__ + "img/calendar_clock.32c91865.svg";